import { makeStyles } from "@material-ui/core";
import jsonExport from "jsonexport/dist";
import moment from "moment";
import * as React from "react";
import { Datagrid, DateField, downloadCSV, Filter, List, ReferenceField, ReferenceInput, SelectInput, TextField, TextInput } from "react-admin";
import AuthorizedCheck from "../../components/Authorized/AuthorizedCheck";
import CommentStatusField from "../../components/CommentEnum/CommentStatusField";
import { commentStatus } from "../enums";

const useStyles = makeStyles((theme) => ({
  hiddenOnSmallScreens: {
    [theme.breakpoints.down("xl")]: {
      display: "none",
    },
  },
}));

const PostFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput
      label="Video Title"
      source="videoId__eq"
      reference="videos"
      sort={{ field: "title", order: "ASC" }}
      //filter={{ status: 3 }}
      //filter="videos.any(x => x.status == $)"
      //filterToQuery={item => (console.log(JSON.stringify(item)))}
      alwaysOn
    >
      <SelectInput optionText="title" />
    </ReferenceInput>
    <SelectInput label="Status" source="status__eq" choices={commentStatus} alwaysOn />
    <TextInput label="Comment" source="userComment__contains" alwaysOn />
  </Filter>
);

const CommentListTitle = () => {
  return <span>Comment List</span>;
};

const exporter = (comments: any[], fetchRelatedRecords) => {
  fetchRelatedRecords(comments, "videoId", "videos").then((video: any) => {
    const commentsForExport = comments.map((comment) => {
      return {
        "Video Title": video[comment?.videoId]?.title,
        Comment: comment?.userComment,
        "Comment Status": commentStatus.filter((row) => row.id == comment?.status)[0].name,
        "Created By": comment?.creatorName,
        "Created Date": comment?.createdDate && moment(comment?.createdDate).format("DD.MM.YYYY"),
      };
    });

    jsonExport(commentsForExport, { rowDelimiter: ";" }, (err: any, csv: any) => {
      if (err) return console.log(err);

      //UTF8
      const bom = "\uFEFF";
      downloadCSV(`${bom} ${csv}`, `CommentList-${moment().format("yyyMMDDHHmmss")}`);
    });
  });
};

const CommentList = (props) => {
  const classes = useStyles();
  return (
    <AuthorizedCheck>
      <List
        {...props}
        bulkActionButtons={false}
        filters={<PostFilter />}
        title={<CommentListTitle />}
        sort={{ field: "createdDate", order: "DESC" }}
        exporter={exporter}
      >
        <Datagrid rowClick="edit">
          <ReferenceField label="Video Title" source="videoId" reference="videos" link={false}>
            <TextField source="title" />
          </ReferenceField>
          <TextField source="userComment" label="Comment" />
          <TextField source="status" headerClassName={classes.hiddenOnSmallScreens} cellClassName={classes.hiddenOnSmallScreens} />
          <CommentStatusField label="Status" />
          <TextField source="creatorName" label="Created By" />
          <DateField source="createdDate" label="Created Date" />
        </Datagrid>
      </List>
    </AuthorizedCheck>
  );
};

export default CommentList;
